export const realtimeEvents = {
    conversationCreated: "chatConversationCreated",
    messageCreated: "chatMessageCreated",
    chatJobUpdated: "chatJobUpdated"
} as const;
